GetBaseUrl = function () {
  var baseUrl = localStorage.getItem("BaseUrl");
  if (baseUrl == null) {
    ErrorAlertMessage("Configuration is missing!");
  } else {
    return baseUrl;
  }
  return null;
};

GetApiCredentials = function (contentType = null) {
  if (contentType != null) {
    return {
      Authorization: "Bearer " + GetToken(),
      Accept: "application/json",
      "Content-Type": contentType,
    };
  }
  return {
    Authorization: "Bearer " + GetToken(),
    Accept: "application/json",
  };
};

// Applicant API's

GetCityList = async function () {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/GetCityList",
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message || "An error occurred while fetching cities"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetDepartmentList = async function (companyId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/GetDepartmentList?companyId=" +
        companyId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching departments"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetJobList = async function (companyId, departmentId, city) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/GetJobList?companyId=" +
        companyId +
        "&departmentId=" +
        departmentId +
        "&city=" +
        city,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message || "An error occurred while fetching jobs"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetLookUpGender = async function () {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/GetLookUpGender",
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching genders"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetLookUpCountryId = async function (companyId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/GetLookUpCountryId?companyId=" +
        companyId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching countries"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetJobDetails = async function (companyId, jobId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/GetJobDetails?companyId=" +
        companyId +
        "&jobId=" +
        jobId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching job details"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

ForgotPassword = async function (companyId, email) {
  try {
    BlockPage();
    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/ForgotPassword?companyId=" +
        companyId +
        "&email=" +
        email,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while processing forget password"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

ValidateApplicant = async function (
  companyId,
  applicantName,
  arabicName,
  nationalId,
  countryRegionId,
  gender,
  dateOfBirth,
  email,
  confirmEmail,
  phone,
  password,
  confirmPassword,
  linkedInLink,
  yearsOfExperience
) {
  try {
    BlockPage();
    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/ValidateApplicant",
      {
        companyId,
        applicantName,
        arabicName,
        nationalId,
        countryRegionId,
        gender,
        dateOfBirth,
        email,
        confirmEmail,
        phone,
        password,
        confirmPassword,
        linkedInLink,
        yearsOfExperience,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data || "An error occurred while validating applicant"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

ApplicantLogin = async function (companyId, userId, password) {
  try {
    BlockPage();
    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/ApplicantLogin",
      {
        companyId,
        userId,
        password,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message || "An error occurred while logging in"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

CreateApplicant = async function (
  companyId,
  applicantName,
  arabicName,
  nationalId,
  countryRegionId,
  gender,
  dateOfBirth,
  email,
  confirmEmail,
  phone,
  password,
  confirmPassword,
  linkedInLink,
  yearsOfExperience
) {
  try {
    BlockPage();
    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/CreateApplicant",
      {
        companyId,
        applicantName,
        arabicName,
        nationalId,
        countryRegionId,
        gender,
        dateOfBirth,
        email,
        confirmEmail,
        phone,
        password,
        confirmPassword,
        linkedInLink,
        yearsOfExperience,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while creating applicant"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetApplicantPersonalInformation = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/GetApplicantPersonalInformation?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching applicant personal information"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetApplicantApplication = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/GetApplicantApplication?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching applicant application"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

WithdrawApplication = async function (applicantId, recId) {
  try {
    BlockPage();
    const response = await axios.put(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/WithdrawApplication?applicantId=" +
        applicantId +
        "&recId=" +
        recId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while withdrawing application"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

UpdateApplicant = async function (
  companyId,
  applicantId,
  arabicName,
  applicantName,
  countryRegionId,
  dateOfBirth,
  email,
  confirmEmail,
  gender,
  phone,
  nationalId,
  linkedInLink,
  yearsOfExperience,
  middleName,
  lastName
) {
  try {
    BlockPage();
    const response = await axios.put(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/UpdateApplicant",
      {
        companyId,
        applicantId,
        arabicName,
        applicantName,
        countryRegionId,
        dateOfBirth,
        email,
        confirmEmail,
        gender,
        phone,
        nationalId,
        linkedInLink,
        yearsOfExperience,
        middleName,
        lastName,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while updating applicant"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

ApplyForJob = async function (companyId, applicantId, recruitmentRecId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/ApplyForJob?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId +
        "&recruitmentRecId=" +
        recruitmentRecId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while applying for job"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

ChangePassword = async function (
  companyId,
  applicantId,
  password,
  newPassword,
  confirmNewPassword
) {
  try {
    BlockPage();
    const response = await axios.put(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/ChangePassword",
      {
        companyId,
        applicantId,
        password,
        newPassword,
        confirmNewPassword,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while changing password"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

ResetPassword = async function (
  companyId,
  email,
  newPassword,
  confirmNewPassword,
  token
) {
  try {
    BlockPage();
    const response = await axios.put(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/ResetPassword",
      {
        companyId,
        email,
        newPassword,
        confirmNewPassword,
        token,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while reseting password"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

ActivateApplicant = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/ActivateApplicant?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while activating applicant"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

Acti = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/Acti?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while activating applicant"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

ActivateA = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/ActivateA?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while activating applicant"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

ResendActivateApplicant = async function (companyId, userId) {
  try {
    BlockPage();
    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/Applicant/ResendActivateApplicant?companyId=" +
        companyId +
        "&userId=" +
        userId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while resending activate applicant"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

// ApplicantProfile API's

GetLookUpEducationLevel = async function (companyId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetLookUpEducationLevel?companyId=" +
        companyId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching educational levels"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetLookUpEducation = async function (companyId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetLookUpEducation?companyId=" +
        companyId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching educations"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetLookUpSkill = async function (companyId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetLookUpSkill?companyId=" +
        companyId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message || "An error occurred while fetching skills"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetLookUpCertificateType = async function (companyId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetLookUpCertificateType?companyId=" +
        companyId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching certificates"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

CreateApplicantEducation = async function (
  companyId,
  applicantId,
  educationDiscipline,
  educationInstitute,
  educationLevel,
  gradePoint,
  startDate,
  endDate,
  description
) {
  try {
    BlockPage();
    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/CreateApplicantEducation",
      {
        companyId,
        applicantId,
        educationDiscipline,
        educationInstitute,
        educationLevel,
        gradePoint,
        startDate,
        endDate,
        description,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while creating applicant education"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetApplicantEducation = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetApplicantEducation?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching applicant education"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

DeleteApplicantEducation = async function (companyId, recId) {
  try {
    BlockPage();
    const response = await axios.delete(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/DeleteApplicantEducation?companyId=" +
        companyId +
        "&recId=" +
        recId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while deleting applicant education"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetLookUpSkillRatingLevel = async function (companyId, skillId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetLookUpSkillRatingLevel?companyId=" +
        companyId +
        "&skillId=" +
        skillId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching skill rating levels"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

CreateApplicantSkill = async function (
  companyId,
  applicantId,
  skillId,
  ratingLevelId
) {
  try {
    BlockPage();
    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/CreateApplicantSkill",
      {
        companyId,
        applicantId,
        skillId,
        ratingLevelId,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while creating applicant skill"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetApplicantSkill = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetApplicantSkill?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching applicant skills"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

DeleteApplicantSkill = async function (companyId, recId) {
  try {
    BlockPage();
    const response = await axios.delete(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/DeleteApplicantSkill?companyId=" +
        companyId +
        "&recId=" +
        recId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while deleting applicant skill"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

CreateApplicantCourse = async function (
  companyId,
  applicantId,
  courseName,
  startDate,
  endDate,
  courseDescription
) {
  try {
    BlockPage();
    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/CreateApplicantCourse",
      {
        companyId,
        applicantId,
        courseName,
        startDate,
        endDate,
        courseDescription,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while creating applicant course"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetApplicantCourse = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetApplicantCourse?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching applicant course"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

DeleteApplicantCourse = async function (companyId, recId) {
  try {
    BlockPage();
    const response = await axios.delete(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/DeleteApplicantCourse?companyId=" +
        companyId +
        "&recId=" +
        recId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while deleting applicant course"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

CreateApplicantCertificate = async function (
  companyId,
  applicantId,
  certificateTypeId,
  unlistedCertificate,
  startDate,
  endDate,
  description,
  certificateType,
  certificateLink,
  attachmentFile
) {
  try {
    BlockPage();
    const formData = new FormData();
    if (certificateType === "file") {
      formData.append("attachmentFile", attachmentFile);
    }

    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/CreateApplicantCertificate?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId +
        "&certificateTypeId=" +
        certificateTypeId +
        "&unlistedCertificate=" +
        unlistedCertificate +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&description=" +
        description +
        "&certificateType=" +
        certificateType +
        "&certificateLink=" +
        certificateLink,
      formData,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while creating applicant certificate"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetApplicantCertificate = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetApplicantCertificate?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching applicant certificate"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

DeleteApplicantCertificate = async function (companyId, recId) {
  try {
    BlockPage();
    const response = await axios.delete(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/DeleteApplicantCertificate?companyId=" +
        companyId +
        "&recId=" +
        recId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while deleting applicant certificate"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

CreateApplicantProfessionalExperience = async function (
  companyId,
  applicantId,
  employerLocation,
  employerPosition,
  nameOfEmployer,
  startDate,
  endDate,
  description
) {
  try {
    BlockPage();
    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/CreateApplicantProfessionalExperience",
      {
        companyId,
        applicantId,
        employerLocation,
        employerPosition,
        nameOfEmployer,
        startDate,
        endDate,
        description,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while creating applicant experience"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetApplicantProfessionalExperience = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetApplicantProfessionalExperience?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching applicant experience"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

DeleteApplicantProfessionalExperience = async function (companyId, recId) {
  try {
    BlockPage();
    const response = await axios.delete(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/DeleteApplicantProfessionalExperience?companyId=" +
        companyId +
        "&recId=" +
        recId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while deleting applicant experience"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

CreateApplicantProjectExperience = async function (
  companyId,
  applicantId,
  role,
  startDate,
  endDate,
  description
) {
  try {
    BlockPage();
    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/CreateApplicantProjectExperience",
      {
        companyId,
        applicantId,
        role,
        startDate,
        endDate,
        description,
      },
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while creating applicant project experience"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetApplicantProjectExperience = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetApplicantProjectExperience?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching applicant project experience"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

DeleteApplicantProjectExperience = async function (companyId, recId) {
  try {
    BlockPage();
    const response = await axios.delete(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/DeleteApplicantProjectExperience?companyId=" +
        companyId +
        "&recId=" +
        recId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while deleting applicant project experience"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

AddAttachment = async function (
  companyId,
  applicantId,
  fileName,
  resumeType,
  resumeLink,
  attachmentFile
) {
  try {
    BlockPage();

    const formData = new FormData();
    formData.append("companyId", companyId);
    formData.append("applicantId", applicantId);
    formData.append("fileName", fileName);
    formData.append("resumeType", resumeType);

    if (resumeType === "file") {
      formData.append("attachmentFile", attachmentFile);
    } else if (resumeType === "url") {
      formData.append("resumeLink", resumeLink);
    }

    const response = await axios.post(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/AddAttachment",
      formData,
      {
        headers: {
          ...GetApiCredentials(),
          ...(resumeType === "file"
            ? { "Content-Type": "multipart/form-data" }
            : {}),
        },
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while validating applicant"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetApplicantAttachment = async function (companyId, applicantId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetApplicantAttachment?companyId=" +
        companyId +
        "&applicantId=" +
        applicantId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response.data;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while fetching applicant attachments"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

DeleteApplicantAttachment = async function (companyId, recId) {
  try {
    BlockPage();
    const response = await axios.delete(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/DeleteApplicantAttachment?companyId=" +
        companyId +
        "&recId=" +
        recId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while deleting applicant education"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};

GetAttachment = async function (companyId, recId) {
  try {
    BlockPage();
    const response = await axios.get(
      "https://recruitment-c0budcdhhkhxfabw.westeurope-01.azurewebsites.net/api/ApplicantProfile/GetAttachment?companyId=" +
        companyId +
        "&recId=" +
        recId,
      {
        headers: GetApiCredentials(),
      }
    );
    return response;
  } catch (error) {
    ErrorAlertMessage(
      error.response?.data?.message ||
        "An error occurred while deleting applicant education"
    );
    throw error;
  } finally {
    UnBlockPage();
  }
};
